import { render, staticRenderFns } from "./PToggle.vue?vue&type=template&id=7124966d"
import script from "./PToggle.vue?vue&type=script&lang=js"
export * from "./PToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports